import * as React from 'react';
import { Loader } from 'components/Loaders/loader';
import { MessageCard } from './MessageCard';

interface Props {
  className?: string;
}

export const Loading: React.FC<Props> = (props) => {
  return (
    <MessageCard
      className={props.className}
      iconography={<Loader />}
      title="Loading Per Diem data…"
    />
  );
};
Loading.displayName = 'Shipments.DetailDrawer.Sections.PerDiem.Loading';
